document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.querySelector('.sticky-atc');
  if (!stickyBar) return;
  
  const triggerPoint = 500;
  const productSection = document.querySelector('#shopify-section-template--25215805423903__main');
  
  const style = document.createElement('style');
  style.textContent = `
    .sticky-atc.custom-show {
      opacity: 1 !important;
      transform: translateY(0) !important;
      visibility: visible !important;
      display: block !important;
    }
    .sticky-atc.custom-hide {
      opacity: 0 !important;
      transform: translateY(100%) !important;
      pointer-events: none !important;
    }
    .scroll-to-top-btn.sticky-bump {
      transform: translateY(-60px) !important;
      transition: transform 0.3s ease !important;
    }
    .scroll-to-top-btn.arrow-down svg {
      transform: rotate(180deg) !important;
      transition: transform 0.3s ease !important;
    }
    .scroll-to-top-btn.custom-hidden {
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity 0.3s ease !important;
    }
  `;
  document.head.appendChild(style);
  
  stickyBar.classList.add('custom-hide');
  
  const scrollBtn = document.querySelector('.scroll-to-top-btn');
  let inCustomZone = false;
  
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function(e) {
      if (inCustomZone && productSection) {
        e.preventDefault();
        e.stopPropagation();
        productSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, true);
  }
  
  window.addEventListener('scroll', function() {
    if (!scrollBtn || !productSection) return;
    
    const productSectionTop = productSection.getBoundingClientRect().top + window.scrollY;
    inCustomZone = window.scrollY > triggerPoint && window.scrollY < productSectionTop;
    const pastProductSection = window.scrollY >= productSectionTop;
    
    if (inCustomZone) {
      stickyBar.classList.remove('custom-hide');
      stickyBar.classList.add('custom-show');
      scrollBtn.classList.add('sticky-bump');
      scrollBtn.classList.add('arrow-down');
      scrollBtn.classList.remove('custom-hidden');
    } else if (window.scrollY <= triggerPoint) {
      stickyBar.classList.remove('custom-show');
      stickyBar.classList.add('custom-hide');
      scrollBtn.classList.remove('sticky-bump');
      scrollBtn.classList.remove('arrow-down');
      scrollBtn.classList.remove('custom-hidden');
    } else if (pastProductSection) {
      // Past product section - hide both
      stickyBar.classList.remove('custom-show');
      stickyBar.classList.add('custom-hide');
      scrollBtn.classList.remove('sticky-bump');
      scrollBtn.classList.remove('arrow-down');
      scrollBtn.classList.add('custom-hidden');
    }
  });
});